/**
 * Controls how the code is bundled. Library mode bundles each package in isolation, while
 * production mode (and development mode once implemented) bundle the full app graph together.
 *
 * Library mode is fastest, but packages must be compliant for loading in the browser.
 */
export type BundleMode = 'library' | 'development' | 'production';
